<template>
  <div class="g-content">
    <div class="g-content-filter">
      <div class="g-content-filter-main">
        <h3>
          {{ isEdit ? $t('com_sider_menu_user_edit') : $t('com_sider_menu_user_add') }}
        </h3>

        <div class="g-content-filter-right">
          <a-button type="default" @click="() => this.$router.go(-1)" icon="double-left">
            {{ $t('com_btn_back') }}
          </a-button>

          <a-button type="primary" @click="handleSubmit">
            {{ $t('com_btn_save') }}
          </a-button>
        </div>
      </div>
    </div>
    <div class="g-content-main common-filter-main">
      <div class="user-form">
        <a-form-model
          :model="form"
          :rules="formRules"
          ref="formElement"
          :label-col="{ span: 5 }"
          :wrapper-col="{ span: 18 }"
          style="width:760px;"
        >
          <!-- 用户名 -->
          <a-form-model-item :label="$t('user_table_userName')" prop="name" style="margin-bottom:0">
            <a-input
              v-model="form.name"
              :placeholder="$t('user_form_userName_placeholder')"
              allowClear
              @input="formInput"
            />
          </a-form-model-item>
          <a-form-model-item label=" " :colon="false" style="margin-bottom:0;">
            <div class="help">
              {{ $t('user_form_userName_help') }}
            </div>
          </a-form-model-item>

          <!-- 昵称 -->
          <a-form-model-item :label="$t('user_table_nickName')" prop="nickName">
            <a-input
              v-model="form.nickName"
              :placeholder="$t('user_form_nickName_placeholder')"
              allowClear
              @input="formInput"
            />
          </a-form-model-item>

          <!-- 头像 -->
          <a-form-model-item :label="$t('user_form_avatar')" prop="avatar" style="width:100%;">
            <UploadOSS
              :value="form.avatar"
              :manuallyUpload="false"
              @change="
                fileList => {
                  form.avatar = fileList || [];
                }
              "
              :maxCount="1"
              ref="uploadFile"
              uploadDirInOSS="images"
              uploadType="image"
            />
          </a-form-model-item>

          <!-- 所属客户 -->
          <a-form-model-item :label="$t('user_form_owner')" prop="customerId">
            <a-select
              :getPopupContainer="triggerNode => triggerNode.parentNode"
              v-model="form.customerId"
              show-search
              :placeholder="$t('user_form_owner_placeholder')"
              style="width:300px"
              :filter-option="filterOption"
              :disabled="isEdit"
            >
              <a-select-option
                v-for="customer in customerList"
                :key="customer.customerId"
                :value="customer.customerId"
              >
                {{ customer.name }}
              </a-select-option>
            </a-select>
          </a-form-model-item>

          <!-- 角色 -->
          <a-form-model-item :label="$t('user_form_role')" prop="roleId">
            <a-select
              :getPopupContainer="triggerNode => triggerNode.parentNode"
              v-model="form.roleId"
              show-search
              :placeholder="$t('user_form_role_placeholder')"
              style="width:300px"
              :filter-option="filterOption"
              :disabled="isEdit"
            >
              <a-select-option v-for="role in roleList" :key="role.id" :value="role.id">
                {{ role.name }}
              </a-select-option>
            </a-select>
          </a-form-model-item>

          <!-- 邮箱 -->
          <a-form-model-item :label="$t('user_table_email')" prop="email">
            <a-input
              v-model="form.email"
              :placeholder="$t('user_form_email_placeholder')"
              allowClear
              @input="formInput"
            />
          </a-form-model-item>

          <!-- 最大可创建站点数 -->
          <a-form-model-item :label="$t('user_form_site_max')" prop="allowCreateMaxStation">
            <a-input
              v-model="form.allowCreateMaxStation"
              :placeholder="$t('user_form_site_max_placeholder')"
              allowClear
              @input="formInput"
            />
          </a-form-model-item>

          <!-- 密码 -->
          <a-form-model-item
            has-feedback
            :label="$t('user_form_password')"
            prop="password"
            style="margin-bottom:0"
            v-if="!isEdit"
          >
            <a-input-password
              v-model="form.password"
              :placeholder="$t('user_form_password_placeholder')"
              autocomplete="off"
            />
          </a-form-model-item>
          <a-form-model-item label=" " :colon="false" style="margin-bottom:0;" v-if="!isEdit">
            <div class="help">
              {{ $t('com_form_password_help') }}
            </div>
          </a-form-model-item>

          <!-- 联系方式 -->
          <a-form-model-item :label="$t('com_form_contact')" prop="contact">
            <a-textarea
              v-model="form.contact"
              :placeholder="$t('com_form_contact_placeholder')"
              :rows="6"
              allowClear
              @input="formInput"
            />
          </a-form-model-item>

          <!-- 备注 -->
          <a-form-model-item :label="$t('com_form_description')" prop="desc">
            <a-textarea
              v-model="form.desc"
              :placeholder="$t('com_form_description_placeholder')"
              :rows="6"
              allowClear
              @input="formInput"
            />
          </a-form-model-item>

          <!-- 错误描述 -->
          <div class="form-error-text">
            <Icon type="error" v-if="formError" />
            <p>{{ formError }}</p>
          </div>
        </a-form-model>
      </div>
    </div>
  </div>
</template>
<script>
import * as RoleAPI from '@/api/system/role';
import * as CustomerAPI from '@/api/system/customer';
import * as API from '@/api/system/user';
import { checkUserName, checkPassword } from '@/libs/validator';
import { mapGetters } from 'vuex';
import RSA from '@/libs/rsa';

export default {
  data() {
    return {
      form: {
        name: undefined,
        nickName: undefined,
        customerId: undefined,
        roleId: undefined,
        email: undefined,
        allowCreateMaxStation: undefined,
        password: undefined,
        contact: undefined,
        desc: undefined,
        avatar: undefined,
      },
      formRules: {
        roleId: [
          {
            required: true,
            message: this.$t('user_form_role_placeholder'),
          },
        ],
        customerId: [
          {
            required: true,
            message: this.$t('user_form_owner_placeholder'),
          },
        ],
        name: [
          {
            required: true,
            message: this.$t('user_form_userName_placeholder'),
          },
          {
            validator: this.validateUserName,
          },
        ],

        email: [
          {
            required: true,
            message: this.$t('user_form_email_placeholder'),
          },
        ],
        allowCreateMaxStation: [
          {
            required: true,
            message: this.$t('user_form_site_max_placeholder'),
          },
        ],

        password: [
          {
            required: true,
            message: this.$t('user_form_password_placeholder'),
          },
          {
            validator: this.validatePassword,
          },
        ],
      },
      formError: '',
      // 角色列表
      roleList: [],

      // 客户列表
      customerList: [],

      loading: false,

      confirmDirty: false,
      info: {},
      id: null,

      // 是否为编辑
      isEdit: false,
    };
  },
  computed: {
    ...mapGetters(['userInfo']),
  },
  created() {
    if (this.$route && this.$route.params && this.$route.params.id) {
      this.isEdit = true;
      delete this.form.password;
      delete this.formRules.password;
    }
    // 先获取form需要的数据
    this.getFormData();
  },
  methods: {
    // 先获取表单数据
    getFormData() {
      const apiList = [
        // 获取所有角色
        this.getAllRoleList(),
        // 获取所有客户
        this.getAllCustomerList(),
      ];

      // 是否为编辑
      if (this.isEdit) {
        apiList.push(this.getUserInfo());
      }

      Promise.all(apiList).finally(() => {
        // 全部接口返回时，清除loading
        this.$store.commit('setPageLoading', false);
      });
    },

    // 获取所有角色
    getAllRoleList() {
      return RoleAPI.RoleListAll().then(res => {
        if (res.code === 0) {
          this.roleList = res.data;
        }
      });
    },

    // 获取所有客户
    getAllCustomerList() {
      return CustomerAPI.CustomerSelect().then(res => {
        if (res.code === 0) {
          this.customerList = res.data;
        }
      });
    },

    // select 过滤
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },

    // 编辑时获取用户数据
    getUserInfo() {
      let id;
      if (this.$route && this.$route.params && this.$route.params.id) {
        id = this.$route.params.id;
      }
      if (!id) {
        return;
      }

      return API.UserDetail({ userId: id }).then(res => {
        if (res.code === 0) {
          this.info = res.data;

          const userInfo = res.data.userInfo;

          // 更新form
          for (const key in userInfo) {
            if (key === 'avatar') {
              this.form[key] = userInfo[key] ? [userInfo[key]] : undefined;
            } else {
              this.form[key] = userInfo[key] || undefined;
            }
          }
        }
      });
    },

    handleSubmit() {
      this.$refs.formElement.validate(valid => {
        if (valid) {
          this.$confirm({
            title: this.$t('user_confirm_save_title'),
            centered: true,
            onOk: () => {
              const params = { ...this.form };

              // 指定字段，格式化两边的空格
              for (const key in params) {
                if (key === 'name') {
                  // RSA加密
                  params[key] = RSA.encrypt(params[key]);
                } else if (key === 'password') {
                  // RSA/MD5加密
                  params[key] = RSA.encrypt(params[key]);
                } else if (key === 'avatar') {
                  params[key] = params[key] && params[key].length > 0 ? params[key][0] : '';
                }
              }

              if (this.isEdit) {
                this.$store.commit('setFreeze', this.$t('com_ongoing_update'));
                params['userId'] = this.info.userInfo.userId;

                API.UserEdit(params)
                  .then(res => {
                    if (res.code === 0) {
                      this.$message.success(this.$t('com_msg_edit_success'));
                      this.$router.replace({ name: 'UserList' });
                    } else {
                      this.formError = res.message;
                    }
                  })
                  .finally(() => {
                    this.$store.commit('setFreeze', false);
                  });
              } else {
                this.$store.commit('setFreeze', this.$t('com_ongoing_save'));

                API.UserAdd(params)
                  .then(res => {
                    if (res.code === 0) {
                      this.$message.success(this.$t('com_msg_save_success'));

                      this.$router.replace({ name: 'UserList' });
                    } else {
                      this.formError = res.message;
                    }
                  })
                  .finally(() => {
                    this.$store.commit('setFreeze', false);
                  });
              }
            },
          });
        }
      });
    },

    // error reset
    formInput() {
      this.formError = '';
    },

    // 验证用户名
    validateUserName(rule, value, callback) {
      if (!checkUserName(value)) {
        callback('Invalid User name!');
        return;
      }
      callback();
    },

    // 验证密码
    validatePassword(rule, value, callback) {
      if (!value) {
        callback();
      }
      if (!checkPassword(value)) {
        callback('Invalid password!');
        return;
      }
      callback();
    },
  },
};
</script>
<style lang="less" scoped>
.user-form {
  max-width: 900px;
  width: 100%;
}
.form-error-text {
  height: 25px;
  line-height: 25px;
  color: #f00;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
  p {
    margin: 0 0 0 10px;
    padding: 0;
  }
}

.help {
  color: #999;
  height: 20px;
  line-height: 20px;
}
</style>
